import { Component, OnInit } from '@angular/core';
import { GameService } from '../../services/game.service';

@Component({
    selector: 'app-day-counter',
    templateUrl: './day-counter.component.html',
    styleUrls: ['./day-counter.component.scss'],
    standalone: false
})
export class DayCounterComponent implements OnInit {
  today = new Date();
  constructor(public gameService: GameService) {}

  ngOnInit() {
    this.gameService.determineDayDifferenceFromStartDate();
    this.gameService.setTrainWidthBasedOnDateDifference();
    this.gameService.buildDateRange();
  }
}
